import Vue from 'vue'
import VueRouter from 'vue-router'
import routerActor from './actor'
import config from '../config/index'

const routerPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    return routerPush.call(this, location).catch(error => error)
}
Vue.use(VueRouter)

/**
 * meta.pPath 用于顶部菜单 选中(尤其在详情页面，其父类菜单要求时选中的)
 * meta.head 默认显示导航1，2显示导航2, -1不显示导航
 * meta.whiteBackground: 默认为灰色背景 true 为白色背景
 */
const routes = [
    ...routerActor,
    {
        // 登录页面
        path: '/',
        name: 'home',
        redirect:'/login'
    },
    {
        // 登录页面
        path: '/login',
        name: 'login',
        component: () => import( /* webpackChunkName: "login" */ '../views/login/login.vue'),
        meta: {
            head: -1, //隐藏
            title: 'login'
        }
    },
    {
        // 消息中心-发送消息
        path: '/chat',
        name: 'Chat',
        component: () => import('../views/chat/chat.vue'),
        meta: {
            title: 'notification',
            roles: ['VISITOR', 'ACTOR']
        }
    },
    {
        // 消息中心-消息列表
        path: '/mail',
        name: 'Mail',
        component: () => import('../views/chat/mail.vue'),
        meta: {
            title: 'notification',
            roles: ['VISITOR', 'ACTOR']
        }
    },
    // {
    //     // 找商机 (商脉圈)
    //     path: '/find-opportunity',
    //     name: 'findOpportunity',
    //     component: () => import( /* webpackChunkName: "findOpportunity" */ '../views/find/findOpportunity.vue'),
    //     meta: {
    //         head: 2,
    //         title: 'finds.businessCircle',
    //         roles: ['VISITOR', 'ACTOR']
    //     }
    // },
    {
        // 观众详情
        path: '/find-person/detail/:id',
        name: 'findPersonDetail',
        component: () => import( /* webpackChunkName: "findPersonDetail" */ '../views/find/findPersonDetail.vue'),
        meta: {
            pPath: '/find/person',
            head: 2,
            title: 'finds.personDetail',
            roles: ['ACTOR', '']
        }
    },
    // {
    //     // 展品详情
    //     path: '/find-exhibit/detail/:id',
    //     name: 'findExhibitDetail',
    //     component: () => import( /* webpackChunkName: "findExhibitDetail" */ '../views/find/findExhibitDetail.vue'),
    //     props: true,
    //     meta: {
    //         pPath: '/find/product',
    //         head: 2,
    //         title: 'finds.productDetail',
    //         roles: ['VISITOR', '']
    //     }
    // },
    // {
    //     // 展商详情
    //     path: '/find-exhibitor/detail/:id',
    //     name: 'findExhibitorDetail',
    //     component: () => import( /* webpackChunkName: "findExhibitorDetail2" */ '../views/find/findExhibitorDetail2.vue'),
    //     props: true,
    //     meta: {
    //         pPath: '/find/actor',
    //         head: 2,
    //         title: 'finds.actorDetail',
    //         roles: ['VISITOR', '']
    //     }
    // },
    {
        path: '/exh-Information',
        name: 'ExhInformation',
        meta: {
            pPath: '/exh-Information',
            title: 'exhibitorInfo',
            roles: ['ACTOR']
        },
        component: () => import('../views/exhInformation/exhInformation')
    },
    {
        // 邀约
        path: '/invite',
        name: 'invite',
        meta: {
            title: 'invitationManagement',
            whiteBackground: true,
            roles: ['VISITOR', 'ACTOR']
        },
        component: () => import('../views/invite/invite.vue')
    },
    {
        // 操作指南
        path: '/operationGuide',
        name: 'operationGuide',
        meta: {
            title: 'operationGuide',
            whiteBackground: true,
            roles: ['ACTOR']
        },
        component: () => import('../views/operationGuide/operationGuide.vue')
    },
    {
        // 商机管理
        path: '/opportunity-manage/:action',
        name: 'opportunityManage',
        component: () => import( /* webpackChunkName: "opportunityManage" */ '../views/find/opportunityManage.vue'),
        meta: {
            title: 'marketing',
            whiteBackground: true,
            roles: ['VISITOR', 'ACTOR']
        }
    },
    {
        //隐私协议
        path: '/agreement',
        name: 'agreement',
        meta: {
            title: 'Privacy agreement',
            head: -1
        },
        component: () => import( /* webpackChunkName: "agreement" */ '../views/login/agreement.vue')
    },
    {
        //足迹 观众（person）,展商（exhibitor）,展品（product）
        path: '/footprint/:type(person|exhibitor|product)',
        name: 'footprintList',
        component: () => import( /* webpackChunkName: "footprintList" */ '../views/footprint/list.vue'),
        meta: {
            title: 'footprints.',
            pPath: {
                'VISITOR': '/footprint/exhibitor',
                'ACTOR': '/footprint/person'
            },
            roles: {
                'person': ['ACTOR'],
                'exhibitor': ['VISITOR'],
                'product': ['VISITOR']
            }
        }
    },
    {
        //收藏 观众（audience）,展商（exhibitor）,展品（product）
        path: '/collection/:type(audience|exhibitor|product)',
        name: 'CollectionList',
        meta: {
            title: 'myFavorite',
            pPath: {
                'VISITOR': '/collection/exhibitor',
                'ACTOR': '/collection/audience'
            },
            roles: {
                'audience': ['ACTOR'],
                'exhibitor': ['VISITOR'],
                'product': ['VISITOR']
            }
        },
        component: () => import('../views/collection/list.vue')
    },

    {
        path: '*',
        name: 'noFind404',
        meta: {
            title: 'Page not found',
            head: 2
        },
        component: () => import( /* webpackChunkName: "404" */ '../views/404.vue')
    }
]

const router = new VueRouter({
    mode: 'history',
    base: config.route || '',
    scrollBehavior: () => ({
        y: 0
    }),
    routes
})

export default router
